"use strict";
/**
* Enums.ts
* Author: Abhilash Panwar (abpanwar)
* Copyright: Microsoft 2016
* Common enum values used in the SDK.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var AWTPiiKind;
(function (AWTPiiKind) {
    AWTPiiKind[AWTPiiKind["NotSet"] = 0] = "NotSet";
    AWTPiiKind[AWTPiiKind["DistinguishedName"] = 1] = "DistinguishedName";
    AWTPiiKind[AWTPiiKind["GenericData"] = 2] = "GenericData";
    AWTPiiKind[AWTPiiKind["IPV4Address"] = 3] = "IPV4Address";
    AWTPiiKind[AWTPiiKind["IPv6Address"] = 4] = "IPv6Address";
    AWTPiiKind[AWTPiiKind["MailSubject"] = 5] = "MailSubject";
    AWTPiiKind[AWTPiiKind["PhoneNumber"] = 6] = "PhoneNumber";
    AWTPiiKind[AWTPiiKind["QueryString"] = 7] = "QueryString";
    AWTPiiKind[AWTPiiKind["SipAddress"] = 8] = "SipAddress";
    AWTPiiKind[AWTPiiKind["SmtpAddress"] = 9] = "SmtpAddress";
    AWTPiiKind[AWTPiiKind["Identity"] = 10] = "Identity";
    AWTPiiKind[AWTPiiKind["Uri"] = 11] = "Uri";
    AWTPiiKind[AWTPiiKind["Fqdn"] = 12] = "Fqdn";
    // Supports scrubbing of the last octet in a IPV4 address. E.g. 10.121.227.147 becomes 10.121.227.*
    AWTPiiKind[AWTPiiKind["IPV4AddressLegacy"] = 13] = "IPV4AddressLegacy";
})(AWTPiiKind = exports.AWTPiiKind || (exports.AWTPiiKind = {}));
